import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';

const Guides = () => {
  return (
    <section id="guides" className="py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-gray-900 to-dark-black border-2 border-gray-800 rounded-2xl p-8 md:p-12">
            <div className="flex items-start gap-6 mb-6">
              <div className="bg-toxic-orange/20 p-4 rounded-lg">
                <BookOpen className="text-toxic-orange" size={40} />
              </div>
              <div className="flex-1">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  How to Play Online Casinos in the UK
                </h2>
                <p className="text-gray-300 leading-relaxed mb-6">
                  Getting started with online casinos in the UK is straightforward, but there are a few things you should know before you deposit. First, make sure you're choosing a licensed operator—look for the UK Gambling Commission logo. Next, understand the welcome bonus terms. Most bonuses come with wagering requirements, which means you'll need to bet a certain amount before you can withdraw winnings. Always read the fine print.
                </p>
                <p className="text-gray-300 leading-relaxed mb-8">
                  When you're ready to play, start by creating an account and verifying your identity. This is a legal requirement and usually takes just a few minutes. Once verified, make your first deposit using a method that suits you—debit cards, e-wallets, or bank transfers are all common options. Remember to set deposit limits and stick to them. Responsible gambling isn't just a buzzword—it's essential for enjoying casino games long-term.
                </p>
                <Link
                  to="/guides"
                  data-discover="true"
                  className="inline-flex items-center text-toxic-orange font-semibold hover:text-orange-400 transition-colors group"
                >
                  Read Full Guide
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guides;

